// Pakketreizen data per continent

export const packagesByContinent = {
  azie: [
    {
      id: 'thailand',
      naam: 'Thailand',
      dagen: 16,
      prijs: 1199,
      populair: true,
      hoogtepunten: ['🛕 Gouden Tempels', '🏖️ Tropische Stranden', '🍜 Streetfood Tours', '🐘 Olifanten Sanctuariums'],
      beschrijving: 'Bangkok, Pattaya, Chiang Mai, Phuket, Khao Sok, Krabi',
      imageKeyword: 'thailand temple beach'
    },
    {
      id: 'sri-lanka',
      naam: 'Sri Lanka',
      dagen: 14,
      prijs: 1099,
      populair: true,
      hoogtepunten: ['🏔️ Sigiriya Rots Beklimmen', '🦁 Safari in Yala', '🍃 Theeplantages Bezoeken', '🏄 Surfen & Stranden'],
      beschrijving: 'Negombo, Sigiriya, Ella, Yala, Weligama, Unawatuna, Colombo',
      image_url: 'https://images.unsplash.com/photo-1566296314736-6eaac1ca0cb9?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'filipijnen',
      naam: 'Filipijnen',
      dagen: 16,
      prijs: 1399,
      hoogtepunten: ['🏝️ Island Hopping', '🤿 Duiken & Snorkelen', '🌊 Kristalhelder Water', '🌅 Zonsondergangen'],
      beschrijving: 'Manila, Palawan, Coron, Cebu, Bohol',
      imageKeyword: 'philippines palawan island'
    },
    {
      id: 'japan',
      naam: 'Japan',
      dagen: 16,
      prijs: 2299,
      hoogtepunten: ['⛩️ Historische Tempels', '🗻 Mount Fuji Bezoeken', '🍱 Authentieke Sushi', '🏙️ Tokyo Verkennen'],
      beschrijving: 'Tokyo, Hakone Mount Fuji, Kyoto, Osaka, Hiroshima, Okinawa',
      image_url: 'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'maleisie',
      naam: 'Maleisië',
      dagen: 14,
      prijs: 1199,
      hoogtepunten: ['🌆 Petronas Towers', '☕ Cameron Highlands', '🕌 Georgetown Cultuur', '🏖️ Langkawi Eiland', '🌴 Optie: Borneo toevoegen (+€500)'],
      beschrijving: 'Kuala Lumpur, Cameron Highlands, Penang George Town, Langkawi. Optie om Borneo toe te voegen voor €1699 p.p.',
      imageKeyword: 'malaysia kuala lumpur penang'
    },
    {
      id: 'cambodja',
      naam: 'Cambodja',
      dagen: 10,
      prijs: 899,
      hoogtepunten: ['🛕 Angkor Wat Zonsopgang', '📜 Khmer Cultuur', '🛶 Tonle Sap Meer', '🏝️ Eiland Paradijs'],
      beschrijving: 'Siem Reap, Phnom Penh, Koh Rong',
      imageKeyword: 'cambodia angkor wat temple'
    },
    {
      id: 'indonesie',
      naam: 'Indonesië',
      dagen: 14,
      prijs: 1299,
      populair: true,
      hoogtepunten: ['🌋 Vulkanen Beklimmen', '🏛️ Borobudur Tempel', '☕ Koffieplantages', '🌿 Jungle Trekking'],
      beschrijving: 'Yogyakarta plus omgeving, Mount Bromo, Ijen Crater, Oost Java',
      imageKeyword: 'indonesia mount bromo java'
    },
    {
      id: 'bali',
      naam: 'Bali',
      dagen: 14,
      prijs: 999,
      hoogtepunten: ['🌾 Rijstterrassen', '🏄 Surfen in Canggu', '🛕 Hindoe Tempels', '🏝️ Gili Eilanden'],
      beschrijving: 'Ubud, Canggu, Uluwatu, Nusa Penida, Gili Eilanden',
      imageKeyword: 'bali ubud rice terraces'
    }
  ],
  
  afrika: [
    {
      id: 'kaapverdie',
      naam: 'Kaapverdië',
      dagen: 16,
      prijs: 1499,
      hoogtepunten: ['🏖️ Sal Stranden', '🌋 Fogo Vulkaan', '🥾 Hiking Santo Antão', '🎵 Kaapverdische Muziek'],
      beschrijving: 'Sal, Fogo, Santo Antão, São Vicente',
      image_url: 'https://images.unsplash.com/photo-1592761684665-92bc9aacf340?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'madagaskar-mauritius',
      naam: 'Madagaskar & Mauritius',
      dagen: 21,
      prijs: 2499,
      hoogtepunten: ['🌳 Baobab Bomen', '🦎 Unieke Wildlife', '🏝️ Paradijselijke Stranden', '🤿 Koraalriffen'],
      beschrijving: 'Antananarivo, Andasibe, Morondava, Baobab Avenue, Nosy Be, Grand Baie, Île aux Cerfs, Le Morne',
      image_url: 'https://images.unsplash.com/photo-1513414653395-3bb68df4b2b3?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'namibie',
      naam: 'Namibië',
      dagen: 16,
      prijs: 1899,
      populair: true,
      hoogtepunten: ['🏜️ Sossusvlei Duinen', '🦏 Safari in Etosha', '🏙️ Koloniale Architectuur', '🌅 Woestijn Zonsondergangen'],
      beschrijving: 'Windhoek, Kalahari, Sossusvlei, Swakopmund, Damaraland, Etosha',
      image_url: 'https://images.unsplash.com/photo-1563994798145-aac79dece602?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'seychellen',
      naam: 'Seychellen',
      dagen: 14,
      prijs: 1799,
      hoogtepunten: ['🏝️ Anse Source d\'Argent', '🤿 Snorkelen', '🐢 Schildpadden Spotten', '⛵ Eiland Hoppen'],
      beschrijving: 'Mahé, Praslin, La Digue, Snorkelen',
      image_url: 'https://images.unsplash.com/photo-1668799229507-6cb083abbe95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzZXljaGVsbGVzJTIwYW5zZSUyMHNvdXJjZSUyMGFlcmlhbCUyMHBhcmFkaXNlJTIwYmVhY2h8ZW58MHx8fHwxNzc2Mzc1NzQ3fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'botswana-zimbabwe',
      naam: 'Botswana & Zimbabwe',
      dagen: 21,
      prijs: 2999,
      hoogtepunten: ['🦁 Big Five Safari', '🌊 Okavango Delta', '💦 Victoria Falls', '🚣 Mokoro Tochten'],
      beschrijving: 'Maun, Okavango Delta, Moremi, Chobe, Victoria Falls, Hwange',
      image_url: 'https://images.unsplash.com/photo-1603201236596-eb1a63eb0ede?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
    },
    {
      id: 'tanzania',
      naam: 'Tanzania',
      dagen: 21,
      prijs: 2599,
      populair: true,
      hoogtepunten: ['🦁 Serengeti Safari', '🌋 Ngorongoro Krater', '🏝️ Zanzibar Stranden', '🐘 Wildlife Fotografie'],
      beschrijving: 'Arusha, Tarangire, Ngorongoro Crater, Serengeti, Stone Town, Zanzibar Beaches',
      image_url: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'zuid-afrika',
      naam: 'Zuid-Afrika',
      dagen: 16,
      prijs: 1899,
      populair: true,
      hoogtepunten: ['🦁 Kruger Safari', '🏔️ Tafelberg', '🍷 Wijnproeven', '🌊 Garden Route'],
      beschrijving: 'Kaapstad, Stellenbosch, Garden Route, Kruger National Park',
      image_url: 'https://images.unsplash.com/photo-1591303872989-2640dc28185b?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'mozambique',
      naam: 'Mozambique',
      dagen: 14,
      prijs: 1799,
      hoogtepunten: ['🤿 Duiken & Snorkelen', '🏝️ Bazaruto Archipel', '🏄 Tofo Beach', '🐋 Walvissen Spotten'],
      beschrijving: 'Maputo, Tofo Beach, Vilanculos, Bazaruto Archipel',
      image_url: 'https://images.unsplash.com/photo-1650876095496-e01d50a6c874?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'congo-rwanda',
      naam: 'Congo & Rwanda',
      dagen: 14,
      prijs: 2199,
      hoogtepunten: ['🦍 Gorilla Trekking', '🌋 Actieve Vulkaan', '🌿 Virunga Jungle', '📸 Wildlife Fotografie'],
      beschrijving: 'Kigali, Volcanoes National Park, Goma, Virunga, Nyiragongo Vulkaan',
      image_url: 'https://images.unsplash.com/photo-1514548383638-cef9251a73ec?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'marokko',
      naam: 'Marokko Rondreis',
      dagen: 12,
      prijs: 999,
      hoogtepunten: ['🕌 Souks van Marrakech', '⛰️ Atlasgebergte', '🐪 Sahara onder de sterren', '🌅 Zandduinen Merzouga', '🌊 Kust van Essaouira'],
      beschrijving: 'Marrakech → Atlasgebergte → Merzouga → Essaouira. Van kleurrijke souks en indrukwekkende bergen tot de Sahara woestijn en sfeervolle kustplaatsen — een perfecte mix van avontuur, cultuur en ontspanning.',
      image_url: 'https://images.unsplash.com/photo-1602859790151-845f2023bee8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb3JvY2NvJTIwc2FoYXJhJTIwZGVzZXJ0JTIwZHVuZXMlMjBzdW5zZXQlMjBkcmFtYXRpY3xlbnwwfHx8fDE3NzYzNzU3OTB8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'tunesie',
      naam: 'Tunesië Rondreis',
      dagen: 12,
      prijs: 999,
      hoogtepunten: ['🏛️ Historisch Tunis', '💙 Wit dorpje Sidi Bou Said', '🐪 Sahara woestijn', '🌴 Stranden van Hammamet', '✨ Souks & lokale gerechten'],
      beschrijving: 'Tunis → Sidi Bou Said → Sahara → Hammamet. Van witte kustdorpjes en woestijnlandschappen tot oude medina\'s en prachtige stranden — Tunesië is één van de meest verrassende bestemmingen van dit moment.',
      image_url: 'https://images.unsplash.com/photo-1726428977637-ba8fc5a5047d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHx0dW5pc2lhJTIwc2lkaSUyMGJvdSUyMHNhaWR8ZW58MHx8fHwxNzc2Mzc0NTk4fDA&ixlib=rb-4.1.0&q=85'
    }
  ],
  
  zuidAmerika: [
    {
      id: 'argentinie',
      naam: 'Argentinië',
      dagen: 21,
      prijs: 2199,
      hoogtepunten: ['💃 Tango in Buenos Aires', '🍷 Wijnstreek Mendoza', '🏔️ Patagonië Gletsjers', '💦 Iguazu Watervallen'],
      beschrijving: 'Buenos Aires, Mendoza, Bariloche, El Calafate, Iguazu Waterval',
      image_url: 'https://images.unsplash.com/photo-1670761624726-c6f3bb48f575?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxhcmdlbnRpbmElMjBidWVub3MlMjBhaXJlcyUyMHBhdGFnb25pYXxlbnwwfHx8fDE3NzYzNzQ1NTB8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'chili',
      naam: 'Chili',
      dagen: 15,
      prijs: 2299,
      hoogtepunten: ['🏜️ Atacama Woestijn', '🌋 Vulkanen', '🏙️ Valparaíso Streetart', '🍷 Wijnproeverijen', '🏔️ Optie: Patagonië toevoegen (+€700)'],
      beschrijving: 'Santiago, Valparaíso, Atacama Woestijn. Optie om Patagonië toe te voegen voor €2999 p.p.',
      image_url: 'https://images.unsplash.com/photo-1612712190432-41852d0187c9?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'peru',
      naam: 'Peru',
      dagen: 16,
      prijs: 1999,
      hoogtepunten: ['🏛️ Machu Picchu', '🥾 Inca Trail', '🦙 Alpaca\'s Ontmoeten', '⛵ Titicacameer'],
      beschrijving: 'Lima, Cusco, Heilige Vallei, Machu Picchu, Titicacameer',
      image_url: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'bolivia',
      naam: 'Bolivia',
      dagen: 16,
      prijs: 1899,
      populair: true,
      hoogtepunten: ['🧂 Uyuni Zoutvlakte', '🏔️ Andes Bergen', '🏙️ La Paz Hoogte', '🦙 Lokale Markten', '🛕 Optie: Peru toevoegen (+€700)'],
      beschrijving: 'La Paz, Uyuni Zoutvlakte, Sucre, Potosi, Andes en Natuur. Optie om Peru toe te voegen voor €2599 p.p.',
      image_url: 'https://images.unsplash.com/photo-1618898695947-f6dac23bd1eb?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'brazilie',
      naam: 'Brazilië',
      dagen: 22,
      prijs: 2599,
      populair: true,
      hoogtepunten: ['🏖️ Copacabana Beach', '🌿 Amazone Jungle', '💃 Samba & Carnaval', '💦 Iguazu Falls'],
      beschrijving: 'Rio de Janeiro, Salvador de Bahia, Amazone Regenwoud, Iguazu, Florianopolis, São Paulo',
      image_url: 'https://images.unsplash.com/photo-1551312183-66bca7944e4e?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'colombia',
      naam: 'Colombia',
      dagen: 16,
      prijs: 1799,
      hoogtepunten: ['☕ Koffie Regio', '🏙️ Cartagena Oude Stad', '💃 Salsa Dansen', '🌴 Caribische Stranden'],
      beschrijving: 'Bogotá, Salento Regio, Medellín, Cartagena',
      image_url: 'https://images.unsplash.com/photo-1620292361418-f48e64590736?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjb2xvbWJpYSUyMGNvZmZlZSUyMHJlZ2lvbiUyMGxhbmRzY2FwZSUyMG1vdW50YWluc3xlbnwwfHx8fDE3NzYzNzU3Njh8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'costa-rica',
      naam: 'Costa Rica',
      dagen: 15,
      prijs: 2199,
      populair: true,
      hoogtepunten: ['🌋 Arenal Vulkaan', '🦥 Luiaards Spotten', '🌉 Hangbruggen', '🏄 Surfen Pacific', '🌴 Optie: Panama toevoegen (+€600)'],
      beschrijving: 'San José, Arenal, Monteverde, Manuel Antonio, Kust. Optie om Panama toe te voegen voor €2799 p.p.',
      image_url: 'https://images.unsplash.com/photo-1580094333632-438bdc04f79f?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    }
  ],
  
  noordAmerika: [
    {
      id: 'barbados',
      naam: 'Barbados',
      dagen: 12,
      prijs: 1899,
      populair: true,
      hoogtepunten: ['Westkust', 'Oostkust', 'Bridgetown', 'Stranden'],
      beschrijving: 'Westkust en Oostkust, Bridgetown',
      image_url: 'https://images.unsplash.com/photo-1717737809437-c8f5e31ef0ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxiYXJiYWRvcyUyMGJlYWNoJTIwY2FyaWJiZWFufGVufDB8fHx8MTc3NjM3NDU1OXww&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'aruba',
      naam: 'Aruba',
      dagen: 12,
      prijs: 1699,
      hoogtepunten: ['Eagle Beach', 'Palm Beach', 'Arikok Park', 'Snorkelen'],
      beschrijving: 'Eagle Beach en Palm Beach, Arikok National Park, Snorkelen, Sunset Beach',
      image_url: 'https://images.unsplash.com/photo-1642119355215-1c8158455f49?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'hawaii',
      naam: 'Hawaï',
      dagen: 14,
      prijs: 2499,
      hoogtepunten: ['Oahu', 'Big Island', 'Maui', 'Surfen'],
      beschrijving: 'Oahu, Big Island, Maui, Surfen en Stranden',
      image_url: 'https://images.unsplash.com/photo-1623055576799-e0644e49887a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxoYXdhaWklMjBiZWFjaCUyMG1hdWklMjBwYXJhZGlzZXxlbnwwfHx8fDE3NzYzNzQ1NTl8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'cuba',
      naam: 'Cuba',
      dagen: 15,
      prijs: 1499,
      hoogtepunten: ['Havana', 'Viñales', 'Trinidad', 'Varadero'],
      beschrijving: 'Havana, Viñales, Trinidad, Cienfuegos, Varadero, Cayo Santa María',
      image_url: 'https://images.unsplash.com/photo-1520496366548-c316918abbc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjdWJhJTIwaGF2YW5hJTIwdmludGFnZSUyMGNhcnN8ZW58MHx8fHwxNzc2Mzc0NTU5fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'bahamas',
      naam: 'Bahamas',
      dagen: 14,
      prijs: 1999,
      hoogtepunten: ['Nassau', 'Exuma', 'Out Islands', 'Stranden'],
      beschrijving: 'Nassau, Exuma Eilanden, Out Islands',
      image_url: 'https://images.unsplash.com/photo-1578280705875-9ed34f079e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxiYWhhbWFzJTIwZXh1bWElMjBiZWFjaCUyMHR1cnF1b2lzZXxlbnwwfHx8fDE3NzYzNzQ1NTl8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'mexico',
      naam: 'Mexico',
      dagen: 21,
      prijs: 1899,
      populair: true,
      hoogtepunten: ['Mexico City', 'Oaxaca', 'Yucatan', 'Tulum'],
      beschrijving: 'Mexico City, Oaxaca, Chiapas, Yucatan, Tulum, Playa del Carmen',
      image_url: 'https://images.unsplash.com/photo-1663601982929-51e28aab0444?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtZXhpY28lMjB0dWx1bSUyMGJlYWNoJTIwcnVpbnN8ZW58MHx8fHwxNzc2Mzc0NTY4fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'canada',
      naam: 'Canada',
      dagen: 16,
      prijs: 2299,
      hoogtepunten: ['Vancouver', 'Banff', 'Jasper', 'Calgary'],
      beschrijving: 'Vancouver, Banff National Park, Jasper National Park, Icefields Parkway, Yoho National Park, Calgary',
      image_url: 'https://images.unsplash.com/photo-1513564774965-ac25ddf81e1e?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    }
  ],
  
  oceanie: [
    {
      id: 'fiji-21',
      naam: 'Fiji',
      dagen: 21,
      prijs: 2399,
      hoogtepunten: ['Viti Levu', 'Yasawa Islands', 'Mamanuca', 'Kleinere Eilanden'],
      beschrijving: 'Viti Levu, Yasawa Islands, Mamanuca Islands, Kleinere Eilanden',
      image_url: 'https://images.unsplash.com/photo-1656071855457-7bdabdd58e7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxmaWppJTIweWFzYXdhJTIwaXNsYW5kcyUyMGFlcmlhbCUyMHByaXN0aW5lJTIwYmVhY2h8ZW58MHx8fHwxNzc2Mzc1Nzc2fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'fiji-28',
      naam: 'Fiji Luxe',
      dagen: 28,
      prijs: 3499,
      hoogtepunten: ['Viti Levu', 'Yasawa Islands', 'Afgelegen Eilanden', 'Luxe Resort'],
      beschrijving: 'Viti Levu, Yasawa Islands, Mamanuca Islands, Afgelegen Islands, Luxe Resort Afsluiting',
      image_url: 'https://images.unsplash.com/photo-1530736822234-c8562cb0a710?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'bora-bora',
      naam: 'Bora Bora',
      dagen: 10,
      prijs: 2099,
      populair: true,
      hoogtepunten: ['Resort Verblijf', 'Lagune Tour', 'Sunset Experience', 'Luxury'],
      beschrijving: 'Resort Verblijf, Lagune Tour, Sunset Experience (aanbevolen met Tahiti te combineren)',
      image_url: 'https://images.unsplash.com/photo-1587408647379-318e9ae26a05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxib3JhJTIwYm9yYSUyMGxhZ29vbiUyMGFlcmlhbCUyMHR1cnF1b2lzZXxlbnwwfHx8fDE3NzYzNzU3Nzd8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'tahiti',
      naam: 'Tahiti',
      dagen: 15,
      prijs: 2299,
      hoogtepunten: ['Papeete', 'Papenoo Valley', 'Westkust', 'Moorea'],
      beschrijving: 'Papeete, Papenoo Valley, Westkust, Moorea Eiland (combineren met Bora Bora?)',
      image_url: 'https://images.unsplash.com/photo-1706868957973-8b656c240dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHx0YWhpdGklMjBtb3VudGFpbnMlMjBhZXJpYWwlMjBwYXJhZGlzZSUyMGxhZ29vbnxlbnwwfHx8fDE3NzYzNzU3Njh8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'samoa',
      naam: 'Samoa',
      dagen: 16,
      prijs: 1999,
      hoogtepunten: ['Apia', 'Upolu', 'Savaii', 'Stranden'],
      beschrijving: 'Apia, Upolu Eiland, Zuidkust Upolu, Savaii Eiland, Relax en Strand (met Fiji of Tonga combineren?)',
      image_url: 'https://images.unsplash.com/photo-1608191522488-315218e38362?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxwYWNpZmljJTIwaXNsYW5kJTIwdHJvcGljYWx8ZW58MHx8fHwxNzc2Mzc0NjA2fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'vanuatu',
      naam: 'Vanuatu',
      dagen: 16,
      prijs: 2099,
      populair: true,
      hoogtepunten: ['Efate', 'Blue Lagunes', 'Tanna Island', 'Jungle'],
      beschrijving: 'Efate, Blue Lagunes, Jungle en Dorpen, Tanna Island, Relax en Kust',
      image_url: 'https://images.unsplash.com/photo-1602587557684-11163fe60c87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHx2YW51YXR1JTIwYmx1ZSUyMGhvbGUlMjBhZXJpYWwlMjBwYXJhZGlzZXxlbnwwfHx8fDE3NzYzNzU3NzZ8MA&ixlib=rb-4.1.0&q=85'
    }
  ],

  europa: [
    {
      id: 'balkan',
      naam: 'Balkan Avontuur',
      dagen: 16,
      prijs: 999,
      populair: true,
      hoogtepunten: ['🌴 Ksamil stranden', '🏰 Berat "1000 ramen"', '🌊 Lake Ohrid', '⚓ Oude stad Kotor', '🏞️ Mostar brug', '✨ Dubrovnik & Split'],
      beschrijving: 'Albanië, Noord-Macedonië, Montenegro, Bosnië & Kroatië. Route: Tirana → Berat → Ksamil → Ohrid → Kotor → Mostar → Dubrovnik → Split. Meerdere landen in één reis - perfecte mix van strand, cultuur & avontuur.',
      image_url: 'https://images.unsplash.com/photo-1504972738139-adc5cfcf91c8?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'baltische-staten',
      naam: 'Baltische Staten',
      dagen: 14,
      prijs: 1049,
      hoogtepunten: ['🏰 Sprookjesachtig Tallinn', '✨ Gezellig Riga', '🏛️ Historisch Vilnius', '🌲 Nationale parken', '🌊 Baltische kust'],
      beschrijving: 'Estland, Letland & Litouwen. Route: Tallinn → Lahemaa National Park → Riga → Jurmala → Vilnius → Trakai. Een uniek Noord-Europa avontuur met hidden gems en sprookjesachtige middeleeuwse steden.',
      image_url: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
    },
    {
      id: 'griekenland-islandhopping',
      naam: 'Griekenland Island Hopping',
      dagen: 14,
      prijs: 1149,
      populair: true,
      hoogtepunten: ['✨ Straatjes van Athene', '🏖️ Stranden van Paros', '🌊 Laidback Naxos', '🌅 Zonsondergangen Santorini'],
      beschrijving: 'Athene, Paros, Naxos & Santorini. Witte huisjes, helderblauw water, beach clubs en eindeloze zonsondergangen.',
      image_url: 'https://images.unsplash.com/photo-1764163863603-0a158f6fdcbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxncmVlY2UlMjBzYW50b3JpbmklMjBzdW5zZXQlMjBjYWxkZXJhJTIwZHJhbWF0aWN8ZW58MHx8fHwxNzc2Mzc1Nzc3fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'italie',
      naam: 'Italië Rondreis',
      dagen: 14,
      prijs: 1399,
      hoogtepunten: ['🚤 Grachten van Venetië', '🎨 Kunst in Florence', '🏛️ Colosseum & Vaticaan', '🌊 Amalfi Coast', '🍋 Positano & Sorrento'],
      beschrijving: 'Venetië → Florence → Rome → Amalfi Coast. Romantische steden, historische plekken, Amalfi Coast en heerlijk eten. De mooiste highlights van Italië in één reis.',
      image_url: 'https://images.unsplash.com/photo-1499678329028-101435549a4e?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'portugal',
      naam: 'Portugal Rondreis',
      dagen: 12,
      prijs: 1099,
      hoogtepunten: ['🍷 Porto wijn & straatjes', '🚋 Lissabon trammetjes', '🌴 Algarve stranden', '🌊 Verborgen baaien', '☀️ Beach clubs Faro'],
      beschrijving: 'Porto → Lissabon → Faro → Algarve. Kleurrijke steden, indrukwekkende kliffen en surf vibes. Perfect voor zon, cultuur & strand.',
      image_url: 'https://images.unsplash.com/photo-1528832135837-894ea33b2f50?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'spanje',
      naam: 'Spanje Rondreis',
      dagen: 15,
      prijs: 1299,
      hoogtepunten: ['🏖️ Strand van Barcelona', '🎨 Valencia markten', '🍷 Tapas in Madrid', '🌊 Zonnige Málaga'],
      beschrijving: 'Barcelona → Valencia → Madrid → Málaga. Bruisende steden, gezellige tapasbarretjes, stranden en nightlife. De perfecte zomerbestemming.',
      image_url: 'https://images.unsplash.com/photo-1512753360435-329c4535a9a7?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
    },
    {
      id: 'malta',
      naam: 'Malta Rondreis',
      dagen: 12,
      prijs: 999,
      hoogtepunten: ['🌴 Valletta straatjes', '🏰 Mdina "Silent City"', '🍹 Beach clubs St. Julian\'s', '🚤 Blue Lagoon Comino', '🌅 Eiland Gozo'],
      beschrijving: 'Valletta → Mdina → St. Julian\'s → Gozo → Comino. Helderblauw water, gezellige straatjes en mediterrane sfeer maken Malta een echt zomerparadijs vol zon en cultuur.',
      image_url: 'https://images.unsplash.com/photo-1584348059301-bb1d44173050?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
    },
    {
      id: 'turkije',
      naam: 'Turkije Rondreis',
      dagen: 12,
      prijs: 999,
      hoogtepunten: ['🕌 Istanbul moskeeën & bazaars', '🎈 Luchtballonnen Cappadocië', '🏜️ Grotwoningen & valleien', '🌊 Turkse kust Antalya'],
      beschrijving: 'Istanbul → Cappadocië → Antalya. Indrukwekkende moskeeën, magische ballonvaarten boven Cappadocië, luxe hotels en prachtige stranden — een onvergetelijke mix van cultuur, natuur en luxe.',
      image_url: 'https://images.unsplash.com/photo-1609519831012-b88942832cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0dXJrZXklMjBjYXBwYWRvY2lhJTIwYmFsbG9vbnxlbnwwfHx8fDE3NzYzNzQ1OTh8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'georgie',
      naam: 'Georgië Rondreis',
      dagen: 14,
      prijs: 1199,
      hoogtepunten: ['🏙️ Rooftop bars Tbilisi', '⛰️ Bergen Kazbegi', '🍷 Wijnproeverijen', '🌿 Watervallen Kutaisi', '🌊 Boulevard Batumi'],
      beschrijving: 'Tbilisi → Kazbegi → Kutaisi → Batumi. Indrukwekkende bergen, wijnregio\'s, bruisende steden en de Zwarte Zee. Een verrassende hidden gem.',
      image_url: 'https://images.unsplash.com/photo-1594766722982-fb4cd139ee7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnZW9yZ2lhJTIwa2F6YmVnaSUyMGNodXJjaCUyMG1vdW50YWlucyUyMGVwaWN8ZW58MHx8fHwxNzc2Mzc1NzkwfDA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 'ijsland',
      naam: 'IJsland Roadtrip',
      dagen: 12,
      prijs: 2199,
      hoogtepunten: ['🚗 Inclusief huurauto', '🖤 Zwart strand Vik', '🧊 Gletsjers & Diamond Beach', '♨️ Hot springs', '🌌 Kans op noorderlicht'],
      beschrijving: 'Reykjavik → Vik → Diamond Beach → Akureyri. Zwarte stranden, watervallen, gletsjers, vulkanen en hot springs. Eén van de mooiste roadtrips van Europa.',
      note: 'Inclusief huurauto',
      image_url: 'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=800&q=80'
    },
    {
      id: 'scandinavie',
      naam: 'Scandinavië Rondreis',
      dagen: 14,
      prijs: 1899,
      populair: true,
      hoogtepunten: ['🚲 Nyhavn Kopenhagen', '🌲 Oslo natuur', '🚆 Treinreis naar Bergen', '🌊 Noorse fjorden', '☕ Stockholm designstad', '🌌 Kans op noorderlicht'],
      beschrijving: 'Kopenhagen → Oslo → Bergen → Stockholm. Indrukwekkende fjorden, kleurrijke steden en één van de mooiste treinreizen van Europa. Ideaal voor zomer én winter.',
      image_url: 'https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
    }
  ]
};

// USA Autoreizen (speciale categorie)
export const usaRoadTrips = [
  {
    id: 'usa-14',
    naam: 'VS Westkust',
    dagen: 14,
    prijs: 2500,
    hoogtepunten: ['Los Angeles', 'Las Vegas', 'Grand Canyon', 'San Francisco'],
    beschrijving: 'LA, Las Vegas, Grand Canyon, Yosemite National Park, San Francisco',
    image_url: 'https://images.unsplash.com/photo-1567344572566-991a70cdd6dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx1c2ElMjBncmFuZCUyMGNhbnlvbiUyMGFyaXpvbmF8ZW58MHx8fHwxNzc2Mzc0NTc5fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'usa-21',
    naam: 'VS Westkust Uitgebreid',
    dagen: 21,
    prijs: 3500,
    hoogtepunten: ['Nationale Parken', 'Monument Valley', 'Route 66', 'Westkust'],
    beschrijving: 'LA, Las Vegas, Zion National Park, Bryce Canyon, Monument Valley, Grand Canyon, Route 66, San Diego, San Francisco',
    image_url: 'https://images.unsplash.com/photo-1739440426807-17eeab8f8f3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxtb251bWVudCUyMHZhbGxleSUyMHJvdXRlJTIwNjZ8ZW58MHx8fHwxNzc2Mzc0NTc3fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'usa-28',
    naam: 'VS Complete Rondreis',
    dagen: 28,
    prijs: 5500,
    hoogtepunten: ['Yellowstone', 'Grand Teton', 'Highway 1', 'Alle Nationale Parken'],
    beschrijving: 'LA, Las Vegas, Zion & Bryce Canyon, Grand Canyon, Route 66 en Arizona, Yellowstone National Park, Grand Teton National Park, San Francisco, Highway 1, San Diego',
    image_url: 'https://images.unsplash.com/photo-1589945751767-ea77ac1ebc2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx5ZWxsb3dzdG9uZSUyMG5hdGlvbmFsJTIwcGFyayUyMHd5b21pbmd8ZW58MHx8fHwxNzc2Mzc0NTc3fDA&ixlib=rb-4.1.0&q=85'
  }
];

// Australië reizen (speciale categorie)
export const australiaTrips = [
  {
    id: 'australie-14',
    naam: 'Australië Hoogtepunten',
    dagen: 14,
    prijs: 2299,
    populair: true,
    hoogtepunten: ['Sydney', 'Cairns', 'Great Barrier Reef', 'Daintree'],
    beschrijving: 'Sydney, Cairns, Great Barrier Reef, Daintree Rainforest',
    image_url: 'https://images.unsplash.com/photo-1659455453824-be36bcdaedba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxhdXN0cmFsaWElMjBncmVhdCUyMGJhcnJpZXIlMjByZWVmfGVufDB8fHx8MTc3NjM3NDU3N3ww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'australie-21',
    naam: 'Australië Oostkust',
    dagen: 21,
    prijs: 2699,
    hoogtepunten: ['Sydney', 'Whitsundays', 'Great Barrier Reef', 'Byron Bay'],
    beschrijving: 'Sydney, Blue Mountains, Byron Bay, Brisbane, Whitsundays Eilanden, Cairns & Great Barrier Reef, Daintree Rainforest',
    image_url: 'https://images.unsplash.com/photo-1610056352054-a68fe4f998e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxhdXN0cmFsaWElMjB3aGl0c3VuZGF5cyUyMGlzbGFuZHN8ZW58MHx8fHwxNzc2Mzc0NTgxfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'australie-28',
    naam: 'Australië Westkust',
    dagen: 28,
    prijs: 3299,
    hoogtepunten: ['Complete Oostkust', 'Alle Hoogtepunten', 'Gold Coast', 'Eilanden'],
    beschrijving: 'Sydney, Blue Mountains, Byron Bay, Brisbane, Whitsundays, Cairns en Great Barrier Reef, Daintree Rainforest, Gold Coast',
    image_url: 'https://images.unsplash.com/photo-1683547896995-d635eec754e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxhdXN0cmFsaWElMjBnb2xkJTIwY29hc3QlMjBxdWVlbnNsYW5kfGVufDB8fHx8MTc3NjM3NDU4OXww&ixlib=rb-4.1.0&q=85'
  }
];

// Nieuw-Zeeland reizen (speciale categorie)
export const newZealandTrips = [
  {
    id: 'nz-21',
    naam: 'Nieuw-Zeeland',
    dagen: 21,
    prijs: 2899,
    populair: true,
    hoogtepunten: ['Auckland', 'Rotorua', 'Queenstown', 'Milford Sound'],
    beschrijving: 'Auckland, Rotorua, Taupo en Tongariro, Wellington, Nelson en Abel Tasman, West Coast, Queenstown en Milford Sound',
    note: 'Auto of Camper',
    image_url: 'https://images.unsplash.com/photo-1466446105453-d151af699ac7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxuZXclMjB6ZWFsYW5kJTIwbWlsZm9yZCUyMHNvdW5kfGVufDB8fHx8MTc3NjM3NDU4OXww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'nz-28',
    naam: 'Nieuw-Zeeland Compleet',
    dagen: 28,
    prijs: 3499,
    hoogtepunten: ['Beide Eilanden', 'Gletsjers', 'Fjorden', 'Vulkanen'],
    beschrijving: 'Auckland, Rotorua, Taupo en Tongariro, Wellington, Nelson en Abel Tasman, West Coast en Gletsjers, Queenstown, Milford Sound, Christchurch',
    note: 'Auto of Camper',
    image_url: 'https://images.unsplash.com/photo-1477209560495-270790f2251a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxuZXclMjB6ZWFsYW5kJTIwZ2xhY2llciUyMG1vdW50YWluc3xlbnwwfHx8fDE3NzYzNzQ1ODl8MA&ixlib=rb-4.1.0&q=85'
  }
];
